import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * « Changer de classe » (SideBarProf) navigue vers l'accueil avec cet état ;
 * la classe active n'est vidée qu'à l'ARRIVÉE, plus au clic (2026-09-29).
 * Une saisie de notes non sauvegardée peut encore retenir la navigation
 * (garde d'EvalDetail) : si le prof choisit de rester, sa classe ne doit pas
 * avoir été vidée entre-temps.
 */
export const ETAT_CHANGER_DE_CLASSE = { changerDeClasse: true };

/** Appelle `viderClasse` une fois à chaque arrivée par « Changer de classe ». */
export default function useArriveeChangerDeClasse(viderClasse) {
    const location = useLocation();
    useEffect(() => {
        if (location.state?.changerDeClasse) viderClasse();
        // Une fois par navigation : viderClasse est recréée à chaque rendu.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);
}
